module.exports = __webpack_public_path__ + "img/ico-attention-gray.3748a14b.svg";